<template>
    <div class="c-banner-wapper">
        <LayoutContent>
            <div class="banner-content">
                <div class="c-banner-text-box">
                    <h5 class="text-item is-title">{{ $t("main:游戏语音GVoice") }}</h5>
                    <p class="text-item is-detail">
                        {{
                            $t(
                                "main:腾讯游戏语音GVoice围绕多种游戏场景打造了实时语音、语音消息、语音识别、范围语音、3D语音、文明语音、魔音、未成年声纹识别系统等行业领先的产品能力，现已服务于全球上千开发商。"
                            )
                        }}
                    </p>
                </div>
                <BannerStatistic /></div
        ></LayoutContent>
    </div>
</template>

<script>
import LayoutContent from "@/components/UI/LayoutContent.vue";
import BannerStatistic from "@/components/UI/BannerStatistic.vue";
export default {
    name: "BannerProduct",
    components: { LayoutContent, BannerStatistic },
};
</script>

<style scoped lang="less">
.c-banner-wapper {
    display: flex;
    justify-content: center;
    position: relative;
    padding-top: 80px;
    padding-left: 24px;
    padding-right: 24px;
    margin-top: -80px;
    background: #151828 url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/product/bg-banner-gvoice.png) no-repeat center center;
    background-size: 1920px;
    .banner-content {
        display: flex;
        flex-direction: column;
        min-height: 720px;
    }
}
.c-banner-text-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 28px;
    .text-item {
        &.is-title {
            font-size: 54px;
            font-weight: normal;
            letter-spacing: -0.4px;
            color: #fff;
        }
        &.is-detail {
            max-width: 640px;
            font-size: 18px;
            line-height: 1.8;
            letter-spacing: -0.6px;
            color: #a1a5af;
        }
        & + .text-item {
            margin-top: 16px;
        }
    }
}

@media only screen and (max-width: 1200px) {
    .c-banner-wapper {
        padding-top: 56px;
        .banner-content {
            min-height: 480px;
            padding-bottom: 24px;
        }
    }
    .c-banner-text-box {
        .text-item {
            &.is-title {
                font-size: 40px;
            }
            &.is-detail {
                font-size: 15px;
            }
        }
    }
}
@media only screen and (max-width: 768px) {
    .c-banner-wapper {
        br {
            display: none;
        }
        .banner-content {
            min-height: 320px;
        }
    }
    .c-banner-text-box {
        .text-item {
            &.is-title {
                font-size: 32px;
            }
            &.is-detail {
                line-height: 1.6;
            }
        }
    }
}
@media only screen and (max-width: 480px) {
    .c-banner-wapper {
        .banner-content {
            min-height: 320px;
        }
    }
    .c-banner-text-box {
        .text-item {
            &.is-title {
                font-size: 24px;
            }
        }
    }
}
</style>
